// extracted by mini-css-extract-plugin
module.exports = {"html":"styles_html__BzFW6","body":"styles_body__C5aUz","container":"styles_container__YJPlC","main":"styles_main__ZYsCT"};